import type { PageList, PageOrSubPageKey } from '@omnia/ui/src/lib'
import { BasePagesEnum, BaseSubPageKey } from '@omnia/ui/src/lib'

export class PagesEnum extends BasePagesEnum {
    public Home = 'Home'
    public Generic = 'Generic'
    public Films = 'Films'
    public FilmDetails = 'FilmDetails'
    public Cinemas = 'Cinemas'
    public Cinema = 'Cinema'
    public AllEvents = 'AllEvents'
    public EventDetails = 'EventDetails'
    public JournalLanding = 'JournalLanding'
    public JournalArticle = 'JournalArticle'
    public JournalAuthor = 'JournalAuthor'
    public Ticketing = 'Ticketing'
    public ReviewTicket = 'ReviewTicket'
    public GiftShop = 'GiftShop'
    public GiftShopCustomerDetails = 'GiftShopCustomerDetails'
    public GiftShopPayment = 'GiftShopPayment'
    public GiftCardConfirmation = 'GiftCardConfirmation'
    public MembershipSales = 'MembershipSales'
    public Membership = 'Membership'
    public Account = 'Account'
    public ResetPassword = 'ResetPassword'
    public TicketBundles = 'TicketBundles'
    public TicketBundlesCustomerDetails = 'TicketBundlesCustomerDetails'
    public TicketBundlesPayment = 'TicketBundlesPayment'
    public TicketBundleConfirmation = 'TicketBundleConfirmation'
}

export class AccountSubPages extends BaseSubPageKey<PagesEnum> {
    public parent: keyof PagesEnum = 'Account'
    public AccountOverview = 'AccountOverview'
    public AccountTransactions = 'AccountTransactions'
    public AccountWatchlist = 'AccountWatchlist'
    public AccountBenefits = 'AccountBenefits'
    public AccountSubscription = 'AccountSubscription'
    public AccountDetails = 'AccountDetails'
    public AccountWallet = 'AccountWallet'
    public AccountPreferences = 'AccountPreferences'
}

export class MembershipSubPages extends BaseSubPageKey<PagesEnum> {
    public parent: keyof PagesEnum = 'Membership'
    public MembershipVoucher = 'MembershipVoucher'
    public MembershipRenewal = 'MembershipRenewal'
    public MembershipPackageSelection = 'MembershipPackageSelection'
    public MembershipSignUp = 'MembershipSignUp'
    public MembershipPayment = 'MembershipPayment'
    public MembershipPhotoUpload = 'MembershipPhotoUpload'
    public MembershipSignUpConfirmation = 'MembershipSignUpConfirmation'
}

export class TicketingSubPages extends BaseSubPageKey<PagesEnum> {
    public parent: keyof PagesEnum = 'Ticketing'
    public SeatPicker = 'SeatPicker'
    public TicketPicker = 'TicketPicker'
    public TicketingLogin = 'TicketingLogin'
    public OrderSummary = 'OrderSummary'
    public OrderPayment = 'OrderPayment'
    public Concessions = 'Concessions'
}

export type PagesType = PageList<PagesEnum, SubPagesType>
export type SubPagesType = TicketingSubPages & AccountSubPages & MembershipSubPages

export type AllPagesKeys = PageOrSubPageKey<PagesEnum, AccountSubPages | TicketingSubPages | MembershipSubPages>
export type PagesKeys = keyof PagesEnum
export type SubPageKeys = keyof SubPagesType
